"use client";

import React, { PropsWithChildren } from "react";

import { CurrentCabinetProvider } from "@/stores/cabinet.store";
import { OrganizationProvider } from "@/stores/organization.store";
import { subscriptionStore, useGetSubscriptionStoreData } from "@/stores/subscription.store";

import { permissionsStore, useGetPermissionStoreData } from "../domains/permission";
import { promocodeStore, useGetPromocodeStoreData } from "../domains/promocode/domain/store";
import { LoaderFullScreen } from "../shared/ui/loader-full-screen";

//

export const OrganizationDataProvider: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <OrganizationProvider fallback={children}>
      <CurrentCabinetProvider>
        <ProvidersGroup1>{children}</ProvidersGroup1>
      </CurrentCabinetProvider>
    </OrganizationProvider>
  );
};

//

const ProvidersGroup1: React.FC<PropsWithChildren> = ({ children }) => {
  const subscriptionData = useGetSubscriptionStoreData();
  const permissionData = useGetPermissionStoreData();
  const promocodeData = useGetPromocodeStoreData();

  if (!subscriptionData || !permissionData || !promocodeData) return <LoaderFullScreen />;

  return (
    <subscriptionStore.Provider value={subscriptionData}>
      <permissionsStore.Provider value={permissionData}>
        <promocodeStore.Provider value={promocodeData}>{children}</promocodeStore.Provider>
      </permissionsStore.Provider>
    </subscriptionStore.Provider>
  );
};
